import React from "react";
import hires from "../../assests/images/hires.svg";
import hiresMobile from "../../assests/images/hiresMobile.svg";
import useResponsiveFlags from "../../hooks/useResponsiveFlags";
import { Link } from "react-router-dom";
export default function HiresText( props) {
  const { isMobile, isDesktop, isDesktopLogin} = useResponsiveFlags();
  const desktopScreen = props.loggedin ? isDesktopLogin : isDesktop
  return (
    <>
      {/* Top Heading Part */}
      <section
        style={{
          background: "#E6F4FA",
        }}
      >
        <div
          style={{
            padding: desktopScreen ? "51px 40px 95px 40px" : "40px 17px 72px 17px",
          }}
        >
          <p>Home &gt; iSort&trade; HiRes</p>
          <div className={desktopScreen ? "d-flex justify-content-between" : ""}>
            <p
              className="heading"
              style={{ width: desktopScreen ? "48%" : "100%", lineHeight: "42px" }}
            >
              iSort&trade; HiRes
            </p>

            <p className="hometext2 para"
              style={{
                width: desktopScreen ? "37%" : "100%",
                marginTop: desktopScreen ? "0" : "2.25rem",
              }}
            >
              <p>
                Using grouped cell composition data from iSort&trade; Fractions,
                iSort&trade; HiRes<strong> infers cell-type-specific gene expression.</strong>
              </p>
              <p>
                Built on iSort&trade;'s Fraction's powerful digital cytometry platform,
                iSort&trade; HiRes provides a deeper level of insight into
                immune cell makeup - and opens up a vast array of possibilities
                across life sciences research.
              </p>
            </p>
          </div>
        </div>
      </section>

      <div
        style={{
          padding: desktopScreen ? "96px 35px 62px 35px" : "62px 20px 62px 20px",
        }}
      >
        {/* Image SVG Part */}
        <div
          className={`${
            desktopScreen ? "" : "d-none"
          } d-flex justify-content-center`}
        >
          <img src={hires} alt="iSort HiRes Process" width="70%" />
        </div>
        {/* Image SVG Part (for mobile)*/}

        <div
          className={`${
            desktopScreen ? "d-none" : ""
          } d-flex justify-content-center`}
        >
          <img src={hiresMobile} alt="iSort HiRes Process" />
        </div>

        {/* features */}
        <div style={{ marginTop: desktopScreen ? "126px" : "90px" }}>
          <p className="home-card-title">Features</p>
          <div className="features-home" style={{ margin: !isMobile ? "34px 20px 0 20px " : "" }}>
            <div className="d-flex flex-column flex-md-row mb-4">
              <div className="col-md-6 d-flex flex-column justify-content-between pe-md-4">
                <p>
                  Using <strong>bulk expression data</strong> and <strong>grouped cell composition data </strong>
                  from iSort&trade; Fractions, <strong>iSort&trade; HiRes</strong> (High Resolution) infers
                  cell-type-specific gene expression.
                </p>
                <hr />
              </div>
              <div className="col-md-6 d-flex flex-column justify-content-between ps-md-4 ">
                <p>
                  The output is a <strong>gene expression matrix</strong> (genes in rows and
                  samples in columns) for <strong>each of the cell types</strong>.
                </p>
                <hr />
              </div>
            </div>

            <div className="d-flex flex-column flex-md-row mb-4">
              <div className="col-md-6 d-flex flex-column justify-content-between pe-md-4">
                <p>
                  iSort&trade; HiRes provides unparalleled resolution and opens up a
                  vast array of possibilities across life science research.
                </p>
                <hr />
              </div>
            </div>
          </div>
        </div>
        {/* button */}
        <div style={{marginTop:"50px"}}>
          <Link to={props.loggedin ? "/runlocally" : "/#getStartedWithHiRes"} className="continue-btn" style={{padding: "10px 25px", textDecoration:"none", fontSize: isMobile? "18px" : "24px"}}>Start using iSort&trade; HiRes &nbsp; &rarr;</Link>
        </div>
      </div>
    </>
  );
}
